import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center h-screen gap-8 px-4 2xl:gap-16" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "w-10 mx-auto border-gray-400 border-1" }, null, -1)
const _hoisted_3 = { class: "flex flex-col items-center gap-4 2xl:gap-8" }
const _hoisted_4 = { class: "flex gap-1" }
const _hoisted_5 = { class: "text-xl text-center text-gray-500 2xl:text-4xl" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-center text-gray-400 2xl:text-2xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Logo),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      (_ctx.secondaryText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.secondaryText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}